/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Archived_ToastInputs */

const en_clients_archived_toast = /** @type {(inputs: Clients_Archived_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client archived.`)
};

const pt_br2_clients_archived_toast = /** @type {(inputs: Clients_Archived_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliente arquivado.`)
};

/**
* | output |
* | --- |
* | "Client archived." |
*
* @param {Clients_Archived_ToastInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_archived_toast = /** @type {((inputs?: Clients_Archived_ToastInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Archived_ToastInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_archived_toast(inputs)
	return pt_br2_clients_archived_toast(inputs)
});